import { FaEye } from 'react-icons/fa';
import { FaTrashCan } from 'react-icons/fa6';
import { RiEdit2Fill } from 'react-icons/ri';

const SetupCard = ({
  title,
  label,
  children,
  deleteBtnTitle,
  disableDeleteBtnTitle,
  editBtnTitle,
  viewBtnTitle,
  disableDeleteBtn,
  showDeleteModalHandler,
  showEditModalHandler,
  showViewModalHandler,
}: {
  title: string;
  label: string | React.ReactNode;
  children?: React.ReactNode;
  disableDeleteBtn?: boolean;
  deleteBtnTitle?: string;
  disableDeleteBtnTitle?: string;
  editBtnTitle?: string;
  viewBtnTitle?: string;
  showDeleteModalHandler?: () => void;
  showEditModalHandler?: () => void;
  showViewModalHandler?: () => void;
}) => {
  // rendering setup card component here
  return (
    <div className='relative bg-base-white border-2 border-base-orange rounded-lg shadow-academia-sm space-y-2 py-3'>
      <div title={title} className='w-4/5 pl-4 pr-2'>
        <h4 className='text-xl italic text-legal-dark-blue font-semibold truncate'>
          {label}
        </h4>
      </div>

      {children && <div className='px-4'>{children}</div>}

      <div className='absolute top-1 right-3 flex items-center justify-center gap-2'>
        {showEditModalHandler ? (
          <button
            title={editBtnTitle}
            onClick={() => showEditModalHandler()}
            className='flex items-center justify-center bg-gray-200 text-base-dark-gray size-7 rounded-full hover:scale-110 hover:bg-base-light-blue hover:text-base-white active:scale-95 duration-300'
          >
            <RiEdit2Fill className='size-4' />
          </button>
        ) : null}

        {showViewModalHandler ? (
          <button
            title={viewBtnTitle}
            onClick={() => showViewModalHandler()}
            className='flex items-center justify-center bg-gray-200 text-base-dark-gray size-7 rounded-full hover:scale-110 hover:bg-base-light-blue hover:text-base-white active:scale-95 duration-300'
          >
            <FaEye className='size-4' />
          </button>
        ) : null}

        {showDeleteModalHandler ? (
          <button
            title={
              disableDeleteBtnTitle ? disableDeleteBtnTitle : deleteBtnTitle
            }
            onClick={() => showDeleteModalHandler()}
            className='flex items-center justify-center bg-gray-200 text-base-dark-gray size-7 rounded-full hover:scale-110 hover:bg-base-red hover:text-base-white active:scale-95 duration-300 disabled:opacity-60 disabled:cursor-not-allowed disabled:hover:bg-gray-200 disabled:hover:text-base-dark-gray disabled:hover:scale-100 disabled:active:scale-100'
            disabled={disableDeleteBtn}
          >
            <FaTrashCan className='size-4' />
          </button>
        ) : null}
      </div>
    </div>
  );
};

export default SetupCard;
